<template>
  <div id="app">
    
    <router-view/>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: 'Home',
  
  mounted(){
    this.WXConfig.wxShowMenu();
    if(this.$route.query.from_user){
      localStorage.from_user = this.$route.query.from_user;
    }
  }

}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
